import * as actionTypes from 'actions';

const initialState = {
  page: 1,
  screen: null,
};

const registerManualReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_PAGINATION_REGISTER_MANUAL: {
      return { ...action.payload };
    }

    case actionTypes.CLEAR_PAGINATION_REGISTER_MANUAL: {
      return { ...initialState };
    }

    default:
      return state;
  }
};

export default registerManualReducer;
